import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CloseIcon from '@material-ui/icons/Close';
import React, { useCallback } from 'react';
import { MainTheme } from '../../../theme';
import { AuthViewType } from '../AuthButtonProps';
import { NewAuthForm } from '../NewAuthForm';
import { useNewAuthDialog } from './NewAuthDialogContext';
interface NewAuthDialogProps {
    view?: AuthViewType;
    title?: string;
    cta?: string;
}

const useStyles = makeStyles(
    (theme) => ({
        content: {
            display: 'flex',
            overflowX: 'hidden',

            '& form > div': {
                [theme.breakpoints.down('xs')]: {
                    minHeight: '100%',
                },
            },

            '& form': {
                width: '100%',
                display: 'block',

                [theme.breakpoints.down('xs')]: {
                    paddingTop: 60,
                },
            },
        },

        close: {
            position: 'absolute',
            top: 8,
            right: 8,
        },
    }),
    {
        name: 'NewAuthDialog',
    },
);

export function NewAuthDialog({ view = 'signIn', title = 'Wooter', cta }: NewAuthDialogProps) {
    const dialog$ = useNewAuthDialog();
    const classes = useStyles();

    const handleClose = useCallback(() => dialog$.setOpen(false), []);
    const isMobile = useMediaQuery<MainTheme>((theme) => theme.breakpoints.down('xs'));
    return (
        <Dialog open={dialog$.open} onClose={handleClose} fullScreen={isMobile}>
            <DialogContent className={classes.content}>
                <IconButton size={'small'} className={classes.close} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <NewAuthForm view={view} title={title} cta={cta} />
            </DialogContent>
        </Dialog>
    );
}

export default NewAuthDialog;
